"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowUpIcon = exports.ArrowDownIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _ArrowDownIcon = _interopRequireDefault(require("../Icons/ArrowDownIcon"));

var _ArrowUpIcon = _interopRequireDefault(require("../Icons/ArrowUpIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowDownIcon = (0, _styledComponents.default)(_ArrowDownIcon.default).withConfig({
  displayName: "ArrowDownIcon",
  componentId: "sc-6ew6j7-0"
})(["color:", ";"], (0, _helpers.color)('black60'));
exports.ArrowDownIcon = ArrowDownIcon;
var ArrowUpIcon = (0, _styledComponents.default)(_ArrowUpIcon.default).withConfig({
  displayName: "ArrowUpIcon",
  componentId: "sc-6ew6j7-1"
})(["color:", ";"], (0, _helpers.color)('black60'));
exports.ArrowUpIcon = ArrowUpIcon;